import { xliff12ToJs } from 'xliff';

/** Turns an xliff into a json **/
export async function xliffToJson(translations: any) {
  const parserResult = await xliff12ToJs(translations, {
    captureSpacesBetweenElements: true,
  });
  const xliffContent = parserResult.resources['ng2.template'];

  return Object.keys(xliffContent).reduce((result: any, current) => {
    const translation = xliffContent[current].target;
    if (typeof translation === 'string') {
      result[current] = translation;
    } else if (Array.isArray(translation)) {
      result[current] = translation
        .map((entry) => {
          if (typeof entry === 'string') return entry;
          if (entry.Standalone?.id) return `{$${entry.Standalone.id}}`;
          if (entry['startTag']?.id) return `<${entry['startTag'].id}>`;
          if (entry['endTag']?.id) return `</${entry['endTag'].id}>`;
          return '[[UNKNOWN]]';
        })
        .join('');
    } else {
      console.warn('Unrecognized translation format:', translation);
      result[current] = '[[UNSUPPORTED_CONTENT]]';
    }
    return result;
  }, {});
}
